import { createEvent, createStore, sample } from 'effector';
import { updatePositionFx, type Position } from '../../entities/position';
import { toastShown } from '../../entities/toast';
import { ApiError } from '../../shared/api/client';
import { i18n } from '../../shared/lib/i18n';

export const editTargetOpened = createEvent<Position>();
export const closed = createEvent();
export const $position = createStore<Position | null>(null)
  .on(editTargetOpened, (_, position) => position)
  .reset(closed, updatePositionFx.done);
export const $error = createStore<string | null>(null)
  .on(updatePositionFx.failData, (_, error) =>
    error instanceof ApiError ? (error.fields.target_pct ?? null) : null,
  )
  .reset(editTargetOpened);

sample({
  clock: updatePositionFx.done,
  filter: ({ params }) => params.patch.target_pct !== undefined,
  fn: () => ({ message: i18n.t('editTarget.saved'), tone: 'neutral' as const }),
  target: toastShown,
});
